import { useState } from 'react';

export default function Merch() {
  const products = [
    {
      id: '1',
      title: 'E.T.C MARY TEE',
      description: 'Premium black tee featuring iconic red face graphic',
      image: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/83bbce8a0925fe48e83b06a6e2eadde5.png',
      hoverImage: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/058dc99eacc54604917ac54c790b42f3.png',
    },
    {
      id: '2',
      title: 'E.T.C HOODIE',
      description: 'Heavyweight hoodie with signature graphics',
      image: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/34c071adf576fa98f16b368a024b75ec.png',
      hoverImage: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/e3f0b78fe39b6d261d398a4e74cc9a29.png',
    },
  ];

  const [hoveredProduct, setHoveredProduct] = useState<string | null>(null);

  return (
    <section id="merch" className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4 tracking-tight">
            OFFICIAL MERCH
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Rep the music. Wear the movement.
          </p>
        </div>

        {/* Products Grid */}
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl" data-product-shop>
            {products.map((product) => (
              <div
                key={product.id}
                className="group bg-zinc-900 overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-red-600/20"
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                {/* Product Image */}
                <div className="relative aspect-square overflow-hidden bg-zinc-800">
                  <img
                    src={hoveredProduct === product.id && product.hoverImage ? product.hoverImage : product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Product Info */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2 tracking-wide">
                    {product.title}
                  </h3>
                  <p className="text-gray-400 mb-4">
                    {product.description}
                  </p>
                  
                  <a
                    href="https://shop.etcmusic.online"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full text-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold tracking-wider transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    BUY NOW
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className="mt-16 text-center bg-gradient-to-r from-red-600 to-red-800 py-12 px-6">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-4">
            MORE DROPS COMING SOON
          </h3>
          <p className="text-lg text-white/90 mb-6">
            New designs dropping regularly. Stay tuned.
          </p>
          <div className="flex justify-center gap-6">
            <a
              href="https://shop.etcmusic.online"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-white text-red-600 font-bold tracking-wider hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              VISIT SHOP
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
